module.exports = __webpack_public_path__ + "img/mastercard.cadb5fcf.png";